import React from 'react';
import ReactDOM from 'react-dom/client';
import Main from './app/js/Main';
import configureStore from "./app/js/redux/Store";
import './app/styles/css/bootstrap.min.css';
import './app/styles/scss/DiyForms.scss';
import './app/styles/scss/UserForm.scss';
import './app/styles/scss/helping.scss';
import "./app/styles/css/output.css";


import { BrowserRouter } from "react-router-dom";
let store= configureStore();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <BrowserRouter>
      <Main store={store} />
    </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
